import { render } from "./report-manager.vue?vue&type=template&id=6492e7c2&ts=true"
import script from "./report-manager.vue?vue&type=script&lang=ts"
export * from "./report-manager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__